import { StatusCodes } from '@e3dc-react/shell/Libs/http-status-codes'
import { ApiResult } from 'src/Libs/api'
import { handleFetchError } from 'src/Libs/api/utils'
import { ShopPopupMessage } from '../models/shop-popup-message.model'
import { ShopAuthFetchWithResponse } from '../types'

interface ShopPopupMessageResponse {
  elements: ShopPopupMessage[]
}

/*
 * Fetches active shop popup messages and orders them by their configured position.
 */
export const fetchShopPopupMessages = async (shopFetch: ShopAuthFetchWithResponse): Promise<ApiResult<ShopPopupMessage[]>> => {
  try {
    const response = await shopFetch<ShopPopupMessageResponse>({
      path: 'e3dc/popup-message',
      method: 'GET',
    })

    if (response.status === StatusCodes.NO_CONTENT) return new ApiResult<ShopPopupMessage[]>([])
    if (response.status === StatusCodes.OK) {
      const messages = response.data.elements.filter(message => message.active).sort((messageA, messageB) => messageA.position - messageB.position)
      return new ApiResult<ShopPopupMessage[]>(messages)
    }

    return new ApiResult<ShopPopupMessage[]>(null, true)
  } catch (error) {
    return handleFetchError<ShopPopupMessage[]>(error)
  }
}
